module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/announcement-components/announcement-list/announcement-list.component.css
// module id = ./src/app/announcement-components/announcement-list/announcement-list.component.css
// module chunks = main